module.exports = __webpack_public_path__ + "static/virginio_augusto-52a2941a0eb606eaf81d5c504e6dce2c.png";